// Asegúrate de que la ruta a tu archivo 'types' sea correcta
import { MinerStatus } from '../types'; 


export const calculateTotalHashrate = (miners: MinerStatus[] | undefined): string => {
  
  if (!miners || miners.length === 0) {
    return '0.000 H/s';
  }

  const litecoinMiners = miners.filter(m => m.algorithm === 'Scrypt');
  const sha256Miners = miners.filter(m => m.algorithm === 'SHA256');
  const dogecoinMiners = miners.filter(m => m.algorithm === 'Scrypt' && m.name.toLowerCase().includes('doge'));
  
  
  const litecoinTotalMH= litecoinMiners.reduce((sum, miner) => sum + miner.hashrate, 0);
  const sha256TotalMH= sha256Miners.reduce((sum, miner) => sum + miner.hashrate, 0);
  const dogecoinTotalMH = dogecoinMiners.reduce((sum, miner) => sum + miner.hashrate, 0);
  
  const litecoinGH = litecoinTotalMH / 1000;
  const dogecoinGH = dogecoinTotalMH / 1000;
  const sha256GH = sha256TotalMH ;
  
  if (litecoinMiners.length > 0 && sha256Miners.length > 0 && dogecoinMiners.length > 0) {
    return `${litecoinGH.toFixed(3)} GH/s + ${sha256GH.toFixed(3)} TH/s`;
  } else if (litecoinMiners.length > 0) {
    return `${litecoinGH.toFixed(3)} GH/s`;
  } else if (sha256Miners.length > 0) {
    return `${sha256GH.toFixed(3)} TH/s`;
  } else if (dogecoinMiners.length > 0){
    return `${dogecoinGH.toFixed(3)} GH/s`;
  }
  
  return '0.000 H/s';
};


export function calculateAVGDifficulty(miners: MinerStatus[] | undefined): { sha256D_AVG: number, scryptD_AVG: number } {

  if (!miners || miners.length === 0) {
    return { sha256D_AVG: 0, scryptD_AVG: 0 };
  }

  const scryptMiners = miners.filter(m => m.algorithm === 'Scrypt' && m.status === 'online');
  const sha256Miners = miners.filter(m => m.algorithm === 'SHA256' && m.status === 'online');

  const calculateAvg = (minerList: MinerStatus[]): number => {
      if (minerList.length === 0) {
          return 0;
      }
      const totalDifficulty = minerList.reduce((sum, miner) => sum + miner.difficulty, 0);
      return totalDifficulty / minerList.length;
  };
  
  return { 
    scryptD_AVG: calculateAvg(scryptMiners), 
    sha256D_AVG: calculateAvg(sha256Miners)
  };
}
